import { skipToken, useQuery } from "@tanstack/react-query";
import { getAuthPhoneVerificationStatus } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const PHONE_VERIFICATION_STATUS_QUERY_KEY = "PHONE_VERIFICATION_STATUS";

export const phoneVerificationStatusKeys = {
  all: [PHONE_VERIFICATION_STATUS_QUERY_KEY],
};

/**
 * Person-level phone verification status. The verified phone lives on the Identity's person
 * Party (the active context's Party can be a company), so this is deliberately independent
 * of the active role context — same answer in Customer and Merchant context.
 */
export const usePhoneVerificationStatusQuery = (isEnabled = true) =>
  useQuery({
    queryKey: phoneVerificationStatusKeys.all,
    queryFn: isEnabled
      ? processResponseWithApiProblemDetails(() =>
          getAuthPhoneVerificationStatus(),
        )
      : skipToken,
  });
